import React, { memo } from "react";
import PropTypes from 'prop-types';

const Highlight = ({ question, query }) => {
    const keyword = query?.trim();

    if (!question) return null;
    // Same wrapper as the highlighted branch, so spacing doesn't shift between a
    // message that matched a search and one that didn't
    if (!keyword) return <p className="mb-0">{question}</p>;

    // Escape the query so one containing regex syntax - "c++", "(", "?" - is
    // matched literally instead of blowing up new RegExp
    const pattern = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // Splitting on a capturing group keeps the matches in the output, so every
    // odd index is an occurrence of the query and every even index is the text
    // around it. Case-insensitive, so the question keeps its own casing.
    const parts = question.split(new RegExp(`(${pattern})`, 'gi'));

    return (
        <p className="mb-0" title={question}>
            {parts.map((part, index) =>
                index % 2 === 1 ? <mark key={index}>{part}</mark> : part
            )}
        </p>
    );
}

Highlight.propTypes = {
    question: PropTypes.string,
    query: PropTypes.string
};

export default memo(Highlight);